import axios from 'axios';
import { ICirStoreCollection, ICirWeekCollection } from 'common/models/commonModel';
import {
  IAnalyzeChannelsChannelShareModel,
  IAnalyzeChannelsChannelShareParams,
  IAnalyzeChannelsChannelShareShiftsModel,
  IAnalyzeChannelsChannelShareShiftsParams,
  IAnalyzeChannelsChannelShareWeeklyModel,
  IAnalyzeChannelsChannelShareWeeklyParams,
} from 'entities/AnalyzeChannels/AnalyzeChannels.models';

const basePath = '/cir-portal/analyze-channels';

export const analyzeChannelsTransport = {
  getStores: (): Promise<ICirStoreCollection> => axios.get(`${basePath}/stores`),
  getWeeks: (): Promise<ICirWeekCollection> => axios.get(`${basePath}/weeks`),
  getChannelShare: (params?: IAnalyzeChannelsChannelShareParams): Promise<IAnalyzeChannelsChannelShareModel> =>
    axios.get(`${basePath}/channel-share`, { params }),
  getChannelShareWeekly: (
    params?: IAnalyzeChannelsChannelShareWeeklyParams
  ): Promise<IAnalyzeChannelsChannelShareWeeklyModel> => axios.get(`${basePath}/channel-share-weekly`, { params }),
  getChannelShareShifts: (
    params?: IAnalyzeChannelsChannelShareShiftsParams
  ): Promise<IAnalyzeChannelsChannelShareShiftsModel> => axios.get(`${basePath}/channel-share-shifts`, { params }),
};
